import z from 'zod';

/**
 * Enum representing the possible statuses of a notification.
 *
 * - `new`: The notification is new and has not been seen by the user.
 * - `seen`: The notification has been seen by the user but not necessarily read.
 * - `read`: The notification has been read by the user, indicating engagement.
 * - `archived`: The notification has been archived by the user for later reference.
 * - `deleted`: The notification has been deleted by the user and is no longer visible.
 */
export const notificationStatusEnumSchema = z.enum([
  'new',
  'seen',
  'read',
  'archived',
  'deleted',
]);

export type NotificationStatusEnum = z.infer<
  typeof notificationStatusEnumSchema
>;
